module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_meme-dadc93904daa80173710a05fcf21343d.jpg";